import { getApi } from 'util/api';

const load = ({ fspId, payerId }, auth) =>
  getApi(`/auth/v2/fsps/${fspId}/payers/${payerId}/cards`, {
    adminUserId: auth.id,
  });

export default load;
